import React from 'react';

export default function Header(){
    return (
        <div class='Header'>
            <h1>nebulous.cloud voice commands</h1>
            <h4>A site by bubblegum</h4>
        </div>
    )
}